import type { SearchFilterState } from './types'

export const XMetaDataFilterKeys = [
  'FUICST',
  'GERP',
  'CSQTRUE',
  'TIP',
  'EXCITAR',
  'GENARGTXT',
  'CSMTEXT',
  'FCTEXT',
  'EPSSTRUE',
  'CATTRUE',
  'Genset',
  'VSPTRUE',
] as const

export const SearchModes = {
  Any: 0,
  All: 1,
} as const

export const MediaTypesValues = {
  Any: 'A',
  Documents: 'D',
  Images: 'I',
  Videos: 'V',
} as const

export const MediaStatuses = {
  Current: 'C',
  NonCurrent: 'N',
} as const

export type InputGroupLabels<T> = Record<keyof T, InputLabels>

export type InputLabels = {
  label: string
}

export const MEDIA_TYPE_LABELS: InputGroupLabels<
  SearchFilterState['mediaType']
> = {
  document: { label: 'Document' },
  image: { label: 'Image' },
  video: { label: 'Videos' },
}

export const MEDIA_STATUS_LABELS: InputGroupLabels<
  SearchFilterState['status']
> = {
  current: { label: 'Current' },
  nonCurrent: { label: 'Non-Current' },
} as const

export const SELECT_OPTIONS_FIELD_NAMES = [
  'markets',
  'categories',
  'productTypes',
  'subIndustries',
  'engineModels',
  'emissionTiers',
  'targetRegions',
  'duties',
  'sources',
  'fuelTypes',
  'frequencies',
  'rpms',
  'voltages',
  'applications',
  'languages',
  'providers',
  'affiliationCodes',
] as const

export const SEARCH_RESULTS_PER_PAGE = [25, 50, 100] as const

export const MAX_SEARCH_RESULTS = 100_000
export const SEARCH_RESULT_EXPORT_LIMIT = 100_000
